module.exports = __webpack_public_path__ + "img/lore.85e75760.jpg";